import styled from 'styled-components'

export const RelationAutocompleteContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 0.25rem;
  align-items: flex-end;

  > :nth-child(2) {
    width: 40px;
    height: 40px;
  }
`
